export default __webpack_public_path__ + "static/media/prod-page-ferramentas.9f0fb217.jpg";